import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import {
  LaundryReceiptHeader,
  LaundryReceiptView,
  LaundryReciptIssueHeader,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import UsePrevious from "../Hook/UsePrevious";
import toast from "react-hot-toast";
import LaundryIssuePopup from "../popup-containers/LaundryIssuePopup";
import LaundryReceiptViewPopup from "../popup-containers/LaundryReceiptViewPopup";
import PopUpButtons from "../components/PopUpButtons";
import LaundryReceiptPopup from "../popup-containers/LaundryReceipt";
import Loader from "../ReusableComponents/Loader";

const LaundryReceipt = () => {
  const [visibleTable, setVisibleTable] = useState(true);
  const [bindLaundryIssue, setBindLaundryIssue] = useState([]);
  const [bindLaundryIssueChild, setBindLaundryIssueChild] = useState([]);

  const [bindLaundryReceipt, setBindLaundryReceipt] = useState([]);
  const [bindLaundryReceiptChild, setBindLaundryReceiptChild] = useState([]);
  const [bindLaundryCompanies, setBindLaundryCompanies] = useState([]);
  const [bindItemType, setBindItemType] = useState([]);
  const [bindItemCategory, setBindItemCategory] = useState([]);
  const [bindItem, setBindItem] = useState([]);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId");
  const [laundryReceiptDetails, setLaundryReceiptDetails] = useState([]);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [laundryReceiptError, setLaundryReceiptError] = useState("");
  const [txnLaundryReceiptId, setTxnLaundryReceiptId] = useState(0);
  const [txnLaundryIssuesId, setTxnLaundryIssuesId] = useState(0);
  const [viewPopupData, setViewPopupData] = useState([]);
  const [viewPopupChildData, setViewPopupChildData] = useState([]);
  const [viewPopupData1, setViewPopupData1] = useState([]);
  const [viewPopupChildData1, setViewPopupChildData1] = useState([]);
  const [viewPopupData2, setViewPopupData2] = useState([]);
  const [viewPopupChildData2, setViewPopupChildData2] = useState([]);

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);

  const [popUpOpen1, setpopUpOpen1] = useState(false);
  const [popUpReceiptOpen, setpopUpReceiptOpen] = useState(false);
  const [tableData, setTableData] = useState([
    {
      MstItemTypeId: "",
      MstItemcategoryId: "",
      MstItemId: "",
      UOM: "",
      IssuedQuantity: "",
      PreviouslyReceivedQuantity: 0,
      ReceiptQuantity: "",
      Balance: "",
      ItemcategoryList: [],
      ItemList: []
    },
  ]);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const previousTableData = UsePrevious(tableData);


  const [laundryReceiptFields, setLaundryReceiptFields] = useState({
    receiptNo: "LRE",
    date: new Date().toISOString().split("T")[0],
    receivedFrom: "",
    receivedBy: "",
    remarks: "",
    issueDate: "",
    issueNo: ""
  });

  const [laundryReceiptFieldsError, setLaundryReceiptFieldsError] = useState({
    receivedFromError: "",
    receivedByError: "",
  });



  useEffect(() => {

    getLaundryIssueDatas();
    getLaundryCompaniesDatas();
    getItemTypeDatas();
    getItemCategoryDatas();
    getItemDatas();
    getLaundryReciptDatas();
  }, []);
  const getLaundryCompaniesDatas = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "LaundryMasterAPI/BindLaundryCompany");
    const getLaundryCompanies =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstLaundryCompanyId,
          label: item.LaundryCompany,
        }))
        : [];
    setBindLaundryCompanies(getLaundryCompanies);
  };

  const getItemTypeDatas = async () => {

    const response = await BindAPI("ItemsAPI/BindItemType");
    const getLaundryCompanies =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }))
        : [];
    setBindItemType(getLaundryCompanies);
  };

  const getItemCategoryDatas = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "ItemscategoryAPI/Binditemscategory");

    setBindItemCategory(response.data.Table);
  };

  const getItemDatas = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "ItemsAPI/BindItems");

    setBindItem(response.data.Table);
  };

  const getLaundryIssueDatas = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    setIsLoading(true)
    const response = await BindPostAPI(data, "LaundryReceiptAPI/BindLaundryReceiptIssues");

    setBindLaundryIssue(response.data.Table);
    setBindLaundryIssueChild(response.data.Table1);
     setIsLoading(false)
     debugger;
  };

  const getLaundryReciptDatas = async () => {
    debugger;
    const data = {
      mstClientId: mstClientId,
    };
     setIsLoading(true)
    const response = await BindPostAPI(data, "LaundryReceiptAPI/BindLaundryReceipts");

    setBindLaundryReceipt(response.data.Table);
    setBindLaundryReceiptChild(response.data.Table1);
     setIsLoading(false)
  };


  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    debugger;
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };
  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setLaundryReceiptDetails(jsonString);
      console.log("data", tableData)

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };


  const handleAddRow = () => {
    setTableData([...tableData,
    {
      MstItemTypeId: "",
      MstItemcategoryId: "",
      MstItemId: "",
      UOM: "",
      IssuedQuantity: "",
      PreviouslyReceivedQuantity: 0,
      ReceiptQuantity: "",
      Balance: "",
      ItemcategoryList: [],
      ItemList: []
    },
    ]);
  };

  const handleDeleteRow = (index) => {

    if (tableData.length != 1) {
      const newData = [...tableData];
      newData.splice(index, 1);
      setTableData(newData);
    } else {
      setTableData([
        {
          MstItemTypeId: "",
          MstItemcategoryId: "",
          MstItemId: "",
          UOM: "",
          IssuedQuantity: "",
          PreviouslyReceivedQuantity: 0,
          ReceiptQuantity: "",
          Balance: "",
          ItemcategoryList: [],
          ItemList: []
        },
      ]);
    }
  };
  const showAdd = () => {
    
    if (selectedRows.length != 0) {
      setVisibleAdd(true);
      setVisibleTable(false);
      setUpdateScreenTitle(false);
      setAddScreenTitle(true);


      const currentDate = bindLaundryIssue[selectedRows].LaundryIssueDate;
      const formattedDate = currentDate.split("T")[0];

      setLaundryReceiptFields({
        issueNo: bindLaundryIssue[selectedRows].LaundryIssueNo,
        issueDate: formattedDate,
        date: new Date().toISOString().split("T")[0],
        receiptNo: "LRE",
        receivedFrom: bindLaundryIssue[selectedRows].MstLaundryCompanyId,
        receivedBy: "",
        remarks: "",

      })

      const txnLaundryIssueId = bindLaundryIssue[selectedRows].TxnLaundryIssuesId;
      setTxnLaundryIssuesId(txnLaundryIssueId);
      const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
        (item) => {
          return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
        }
      );
      if (laundryIssueData.length === 0) {
        setTableData([
          {
            MstItemTypeId: "",
            MstItemcategoryId: "",
            MstItemId: "",
            UOM: "",
            Quantity: "",
            IssuedQuantity: "",
            PreviouslyReceivedQuantity: 0,  
            ReceiptQuantity: "",
            Rate: "",
            ItemcategoryList: [],
            ItemList: []
          },
        ]);
      } else {
        // Append the filtered data to your state using appendDataToState function
        appendDataToCommoditiesTable(JSON.stringify(laundryIssueData));
      }
    } else {
      toast.error("Select Checkbox", {
        duration: 2000,
        position: "top-center",
      });
    }
  };

  const handleEdit = (rowIndex) => {

    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    const currentDate = bindLaundryReceipt[rowIndex].Date;
    const formattedDate = currentDate.split("T")[0];


    const currentDate1 = bindLaundryReceipt[rowIndex].IssueDate;
    const formattedDate1 = currentDate1.split("T")[0];

    setLaundryReceiptFields({
      issueNo: bindLaundryReceipt[rowIndex].IssueNo,
      issueDate: formattedDate1,
      date: formattedDate,
      receiptNo: bindLaundryReceipt[rowIndex].ReceiptNo,
      receivedFrom: bindLaundryReceipt[rowIndex].MstLaundryCompanyId,
      receivedBy: bindLaundryReceipt[rowIndex].ReceivedBy,
      remarks: bindLaundryReceipt[rowIndex].Remarks,

    })
    const txnLaundryReceiptsId = bindLaundryReceipt[rowIndex].MstLaundryReceiptsId;
    setTxnLaundryReceiptId(txnLaundryReceiptsId)
    setTxnLaundryIssuesId(bindLaundryReceipt[rowIndex].MstLaundryIssuesId)
    const laundryReceiptsData = Object.values(bindLaundryReceiptChild).filter(
      (item) => {
        return String(item.MstLaundryReceiptsId) === String(txnLaundryReceiptsId);
      }
    );
    if (laundryReceiptsData.length === 0) {
      setTableData([
        {
          MstItemTypeId: "",
          MstItemcategoryId: "",
          MstItemId: "",
          UOM: "",
          IssuedQuantity: "",
          PreviouslyReceivedQuantity: 0,
          ReceiptQuantity: "",
          Balance: "",
          ItemcategoryList: [],
          ItemList: []
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToCommoditiesTable1(JSON.stringify(laundryReceiptsData));
    }

  };



  const handleIssueView = (rowIndex, flag) => {
    setpopUpOpen(true);

    const rowData = bindLaundryIssue[rowIndex]

    const txnLaundryIssueId = bindLaundryIssue[rowIndex].TxnLaundryIssuesId;

    const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
      (item) => {
        return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
      }
    );

    setViewPopupData(rowData)
    setViewPopupChildData(laundryIssueData)
  };

  const handleReceiptView = (rowIndex, flag) => {
    setpopUpReceiptOpen(true);


    const rowData = bindLaundryReceipt[rowIndex]

    const txnLaundryReceiptId = bindLaundryReceipt[rowIndex].MstLaundryReceiptsId;

    const laundryReceiptData = Object.values(bindLaundryReceiptChild).filter(
      (item) => {
        return String(item.MstLaundryReceiptsId) === String(txnLaundryReceiptId);
      }
    );

    setViewPopupData1(rowData)
    setViewPopupChildData1(laundryReceiptData)
  };

  const handlePopup = (rowIndex, flag) => {

    setpopUpOpen1(true)
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    const rowData = bindLaundryReceipt[rowIndex]

    const txnLaundryReceiptId = bindLaundryReceipt[rowIndex].MstLaundryReceiptsId;
    setTxnLaundryReceiptId(txnLaundryReceiptId)
    const laundryIssueData = Object.values(bindLaundryReceiptChild).filter(
      (item) => {
        return String(item.MstLaundryReceiptsId) === String(txnLaundryReceiptId);
      }
    );


    setViewPopupData2(rowData)
    setViewPopupChildData2(laundryIssueData)
  };


  const cancel = async () => {
    setpopUpOpen(false);
    setpopUpOpen1(false);
    setpopUpReceiptOpen(false);
    setLaundryReceiptError("");
    setSelectedRows([]);
    setVisibleAdd(false);
    setVisibleTable(true);
   
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setLaundryReceiptFields({
      receiptNo: "LRE",
      date: new Date().toISOString().split("T")[0],
      receivedFrom: "",
      receivedBy: "",
      remarks: "",
      issueDate: "",
      issueNo: ""
    });
    setLaundryReceiptFieldsError({
      receivedFromError: "",
      receivedByError: "",
    });
    setTableData([...tableData,
    {
      MstItemTypeId: "",
      MstItemcategoryId: "",
      MstItemId: "",
      UOM: "",
      IssuedQuantity: "",
      PreviouslyReceivedQuantity: 0,
      ReceiptQuantity: "",
      Balance: "",
      ItemcategoryList: [],
      ItemList: []
    },
    ]);

    getLaundryIssueDatas();
    getLaundryCompaniesDatas();
    getItemTypeDatas();
    getItemCategoryDatas();
    getItemDatas();
    getLaundryReciptDatas();
     setIsLoading(false);
  };

  const handle1 = (value) => {
    setSelectedRows(value);
    setCheckBoxStatus(value);
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...laundryReceiptFieldsError,
        receivedFromError:
          laundryReceiptFields.receivedFrom > 0 ? "" : "Select Received From",
        receivedByError: laundryReceiptFields.receivedBy?.trim()
          ? ""
          : "Enter Received By",
      };

      let hasLaundryReceiptErrors = false;

      if (laundryReceiptDetails.length === 0) {
        setLaundryReceiptError("Fill the above table");
      } else {
        let laundryReceiptData = [];
        try {
          laundryReceiptData = JSON.parse(laundryReceiptDetails);
        } catch (error) {
          console.error("Error parsing Laundry Receipt data:", error);
          setLaundryReceiptError("Error parsing Laundry Receipt data");
          return; // Exit the function early if there's an error
        }

        if (!Array.isArray(laundryReceiptData)) {
          console.error("Laundry Receipt data is not an array");
          setLaundryReceiptError("Laundry Receipt data is not an array");
          return; // Exit the function early if data is not an array
        }

        const laundryReceiptError = laundryReceiptData.map((laundryReceipt) => {
          if (
            !laundryReceipt ||
            !laundryReceipt.MstItemTypeId ||
            !laundryReceipt.MstItemcategoryId ||
            !laundryReceipt.MstItemId ||
            !laundryReceipt.UOM ||
            laundryReceipt.ReceiptQuantity == null ||
            laundryReceipt.IssuedQuantity == null ||
            laundryReceipt.Balance == null
          ) {
            return "Laundry Receipt information is incomplete";
          }
          return null;
        });

        hasLaundryReceiptErrors = laundryReceiptError.some(
          (error) => error !== null
        );

        if (!hasLaundryReceiptErrors) {
          setLaundryReceiptError("");
          hasLaundryReceiptErrors = true;
        } else {
          setLaundryReceiptError(
            "Please provide complete Laundry Receipt information"
          );
          hasLaundryReceiptErrors = false;
        }
      }

      setLaundryReceiptFieldsError(isFormError);

      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );

      if (isFormValid && hasLaundryReceiptErrors) {
        const payload = {
          mstLaundryReceiptsId: txnLaundryReceiptId ? txnLaundryReceiptId : 0,
          mstClientId: mstClientId,
          mstLaundryIssuesId: txnLaundryIssuesId,
          receiptNo: laundryReceiptFields.receiptNo,
          issueNo: laundryReceiptFields.issueNo,
          date: laundryReceiptFields.date,
          issueDate: laundryReceiptFields.issueDate,
          mstLaundryCompanyId: laundryReceiptFields.receivedFrom,
          receivedBy: laundryReceiptFields.receivedBy,
          laundryReceipts: laundryReceiptDetails,
          remarks: laundryReceiptFields.remarks,
          createdBy: createdBy,
          flag: flag,
        };

        const response = await IUDAPI(
          payload,
          "LaundryReceiptAPI/IUDLaundryReceipts"
        );

        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Laundry Receipt Added Successfully 👍", {
              duration: 4000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed To Add Laundry Receipt 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Laundry Receipt Modified Successfully 👍", {
              duration: 4000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed To Modified Laundry Receipt 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      // Flag = 3 (Delete)
      const payload = {
        mstLaundryReceiptsId: txnLaundryReceiptId ? txnLaundryReceiptId : 0,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(
        payload,
        "LaundryReceiptAPI/IUDLaundryReceipts"
      );

      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(`Laundry Receipt data deleted successfully 🗑️`, {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error(`Failed to delete Laundry Receipt data 👎`, {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };


  useEffect(() => {

    updateTableData();
  }, [tableData]);
  const updateTableData = async () => {
debugger;
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData]; // Clone the current table data

      // Iterate through each row
      for (const row of updatedTableData) {
        if (row?.MstItemTypeId) {
          const getFilteredCategory = bindItemCategory
            .filter(
              (item) => item.MstItemTypeId === row.MstItemTypeId
            )
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.ItemcategoryList = getFilteredCategory;
        }

        if (row?.MstItemcategoryId) {
          const selectedCategory = bindItem
            .filter(
              (item) => item.MstItemCategoryId === row.MstItemcategoryId
            )
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.ItemList = selectedCategory;

          // Find the selected commodity for the row and set its unit of measure
          const selectedCommodity = selectedCategory.find(
            (item) => item.value === row.MstItemId
          );
          row.UOM = selectedCommodity?.uom || ""; // Reset if no selected commodity
      //    row.PreviouslyReceivedQuantity = row.PreviouslyReceivedQuantity || 0 + parseInt(row.ReceiptQuantity || 0);
        }

      }

      setTableData(updatedTableData);
    }
  };

  const appendDataToCommoditiesTable = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
debugger;
      return {
        MstItemTypeId: data.MstItemTypeId,
        MstItemcategoryId: data.MstItemcategoryId,
        MstItemId: data.MstItemId,
        UOM: data.UOM,
        IssuedQuantity: data.Quantity,
        PreviouslyReceivedQuantity: data.LastIssuedQuantity,
        Rate: data.Rate,
        ReceiptQuantity: null,
        Balance: data.Balance,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);

  };


  const appendDataToCommoditiesTable1 = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
debugger;
      return {
        MstItemTypeId: data.MstItemTypeId,
        MstItemcategoryId: data.MstItemcategoryId,
        MstItemId: data.MstItemId,
        UOM: data.UOM,
        IssuedQuantity: data.IssuedQuantity,
        PreviouslyReceivedQuantity: data.PreviouslyReceivedQuantity,
        ReceiptQuantity: data.ReceivedQuantity,
        Balance: data.Balance,

      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);

  };


  const updateTableData1 = async (formattedDataArray) => {

    if (JSON.stringify(previousTableData) !== JSON.stringify(formattedDataArray)) {
      const updatedTableData = [...formattedDataArray]; // Clone the current table data

      // Iterate through each row
      for (const row of updatedTableData) {
        if (row?.MstItemTypeId) {
          const getFilteredCategory = bindItemCategory
            .filter(
              (item) => item.MstItemTypeId === row.MstItemTypeId
            )
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.ItemcategoryList = getFilteredCategory;
        }

        if (row?.MstItemcategoryId) {
          const selectedCategory = bindItem
            .filter(
              (item) => item.MstItemCategoryId === row.MstItemcategoryId
            )
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.ItemList = selectedCategory;

          // Find the selected commodity for the row and set its unit of measure
          const selectedCommodity = selectedCategory.find(
            (item) => item.value === row.MstItemId
          );
          row.UOM = selectedCommodity?.uom || ""; // Reset if no selected commodity
        }

      }

      setTableData(updatedTableData);
    }
  };

  return (
    <div>
      <MainLayout pageName={"2"}>
        <Loader
                isVisible={isLoading}
                size="h-20 w-20"
                color="border-t-black"
                blur={true}
              />
        {visibleTable && (
          <GridPageWithCheckBox
            title="Issues"
            header={LaundryReciptIssueHeader}
            checkBoxVisible={true}
            checkBoxStatus={handle1}
            selectedRows={selectedRows ?? []}
            records={bindLaundryIssue}
            blockView={true}
            showAdd={showAdd}
            onLaundryIssueView={handleIssueView}
          />
        )}

        {visibleTable && (
          <GridPage
            title="Receipts"
            header={LaundryReceiptHeader}
            records={bindLaundryReceipt}
            handleAction={handlePopup}
            handleEdit={handleEdit}
            blockView={true}
            addView={true}
            onLaundryIssueView={handleReceiptView}
          />
        )}

        {visibleAdd && (
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  title="Receipts"
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                />
              </div>
            </div>

            <div className={mainTable.mainContentScreen}>
              <form className={mainTable.formForClientMaster}>
                <div className={mainTable.grid3}>
                  <InputText
                    title="Receipt No"
                    name="receiptNo"
                    placeholder="Receipt No"
                    disabled={true}
                    // tabIndex="1"
                    content={laundryReceiptFields.receiptNo}
                  />

                  <InputText
                    inputType="date"
                    title="Received Date"
                    classStar="text-red-500"
                    name="date"
                    content={laundryReceiptFields.date}
                    controlFunc={(e) =>
                      setLaundryReceiptFields({
                        ...laundryReceiptFields,
                        date: e.target.value,
                      })
                    }
                    // tabIndex="1"
                  />

                  <DropDown
                    title="Received From"
                    name="receivedFrom"
                    classStar="text-red-500"
                    selectedOption={laundryReceiptFields.receivedFrom}
                    disabled={true}
                    options={bindLaundryCompanies}
                    controlFunc={(e) => {
                      setLaundryReceiptFields({
                        ...laundryReceiptFields,
                        receivedFrom: e.target.value,
                      });
                    }}

                    placeholder="Select"
                    controlFuncBlur={(e) => {
                      const value = e.target.value;
                      setLaundryReceiptFieldsError((prev) => ({
                        ...prev,
                        receivedFromError: value
                          ? ""
                          : "Select Received From",
                      }));
                    }}

                    errorMessage={laundryReceiptFieldsError.receivedFromError}
                    // tabIndex="1"
                  />

                  <InputText
                    inputType="text"
                    title="Received By"
                    name="receivedBy"
                    content={laundryReceiptFields.receivedBy}
                    controlFunc={(e) => {
                      {
                        const inputVal = e.target.value;
                        const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                        if (onlyLettersRegex.test(inputVal)) {
                          setLaundryReceiptFields({
                            ...laundryReceiptFields,
                            receivedBy: e.target.value,
                          });
                        }
                      }
                    }}
                    controlFuncBlur={() => {
                      const trimmedBank =
                        laundryReceiptFields.receivedBy?.trim() || "";
                      setLaundryReceiptFieldsError(() => ({
                        ...laundryReceiptFieldsError,
                        receivedByError: trimmedBank ? "" : "Enter Received By",
                      }));
                    }}
                    // tabIndex="1"
                    errorMessage={laundryReceiptFieldsError.receivedByError}

                  />

                  <InputText
                    inputType="text"
                    title="Issue No"
                    name="issueNo"
                    classStar="text-red-500"
                    disabled={true}
                    content={laundryReceiptFields.issueNo}
                    // tabIndex="1"
                  />

                  <InputText
                    inputType="date"
                    title="Issue Date"
                    classStar="text-red-500"
                    name="date"
                    content={laundryReceiptFields.issueDate}
                    disabled={true}
                    // tabIndex="1"
                  />
                </div>

                <table className="min-w-full table-auto border border-gray-300">
                  <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
                    <tr>
                      <th className="border px-2 py-2 w-[30px]">S.No</th>
                      <th className="border px-4 py-2 w-[180px]">Item Type</th>
                      <th className="border px-4 py-2 w-[180px]">Category</th>
                      <th className="border px-4 py-2 w-[180px]">Name</th>
                      <th className="border px-4 py-2 w-[80px]">U.O.M</th>
                      <th className="border px-4 py-2 w-[80px]">
                        Issued Quantity
                      </th>
                      <th className="border px-4 py-2 w-[80px]">
                        Prev. Received Quantity
                      </th>
                      <th className="border px-4 py-2 w-[80px]">
                        Received Quantity
                      </th>
                      <th className="border px-4 py-2 w-[80px]">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index}>
                        <td className="border px-2 py-2 w-[30px]">
                          {index + 1}
                        </td>

                        <td className="border px-4 py-2">
                          <AutoDropDown
                            options={bindItemType}
                            placeholder="Select"
                            name="MstItemTypeId"
                            Class="p-0"
                            disabled={true}
                            selectedOption={bindItemType.find(
                              (x) => x.value == row.MstItemTypeId
                            )}
                            controlFunc={(e) =>
                              handleInputChange(e, index, "MstItemTypeId")
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <AutoDropDown
                            options={row.ItemcategoryList || []}
                            placeholder="Select"
                            name="MstItemcategoryId"
                            disabled={true}
                            Class="p-0"
                            selectedOption={row.ItemcategoryList?.find(
                              (x) => x.value === row.MstItemcategoryId
                            )}
                            controlFunc={(e) =>
                              handleInputChange(e, index, "MstItemcategoryId")
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <AutoDropDown
                            options={row.ItemList || []}
                            placeholder="Select"
                            name="MstItemId"
                            disabled={true}
                            Class="p-0"
                            selectedOption={row.ItemList?.find(
                              (x) => x.value === row.MstItemId
                            )}
                            controlFunc={(e) =>
                              handleInputChange(e, index, "MstItemId")
                            }
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.UOM}
                            maxLength={10}
                            disabled={true}
                            controlFunc={(e) => {
                              debugger;
                              const InputText = e.target.value;

                              if (/^[A-Za-z]*$/.test(InputText)) {
                                handleInputChange(e.target, index, "UOM");
                              }
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.IssuedQuantity}
                            maxLength={5}
                            disabled={true}
                            controlFunc={(e) => {
                              debugger;
                              const inputValue = e.target.value;

                              // Allow empty string or digits only (prevents non-numeric input)
                              if (inputValue === '' || /^\d+$/.test(inputValue)) {
                                handleInputChange(e.target, index, "IssuedQuantity");
                              }
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.PreviouslyReceivedQuantity || 0}
                            maxLength={5}
                            disabled={true}
                            // controlFunc={(e) => {
                            //   const inputValue = e.target.value;

                            //   // Allow empty string or digits only (prevents non-numeric input)
                            //   if (inputValue === '' || /^\d+$/.test(inputValue)) {
                            //     handleInputChange(e.target, index, "PreviouslyReceivedQuantity");
                            //   }
                            // }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.ReceiptQuantity}
                            maxLength={5}
                            controlFunc={(e) => {
                              const inputValue = e.target.value;

                              // Allow empty string or digits only (prevents non-numeric input)
                              if (inputValue === '' || /^\d+$/.test(inputValue)) {
                                const receiptQty = Number(inputValue);
                                const issuedQty = Number(row.IssuedQuantity);
                                const previouslyIssuedQty = Number(row.PreviouslyReceivedQuantity || 0);
                                // Prevent ReceiptQuantity > IssuedQuantity
                                if (receiptQty > issuedQty) {
                                  toast.error("Receipt Quantity cannot be greater than Issued Quantity", {
                                    duration: 2000,
                                    position: "top-center",
                                  });
                                  return;
                                }

                                // Update ReceiptQuantity
                                handleInputChange(e.target, index, "ReceiptQuantity");

                                // Update Balance
                                const newBalance = issuedQty - previouslyIssuedQty - receiptQty;
                                const syntheticEvent = { target: { value: newBalance.toString() } };
                                handleInputChange(syntheticEvent.target, index, "Balance");
                              }
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.Balance}
                            maxLength={5}
                            disabled={true}
                            controlFunc={(e) => {

                              const inputValue = e.target.value;

                              // Allow empty string or digits only (prevents non-numeric input)
                              if (inputValue === '' || /^\d+$/.test(inputValue)) {
                                handleInputChange(e.target, index, "Balance");
                              }
                            }}
                          />
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="hidden md:block">
                  {laundryReceiptError && (
                    <div className="text-red-500">{laundryReceiptError}</div>
                  )}
                </div>
                <br />

                <TextArea
                  title="Remarks"
                  name="remarks"
                  placeholder="Remarks"
                  // tabIndex="1"
                  maxLength={500}
                  rows={4}
                  content={laundryReceiptFields.remarks}
                  controlFunc={(e) => {
                    setLaundryReceiptFields({
                      ...laundryReceiptFields,
                      remarks: e.target.value,
                    });
                  }}
                />


                <div className="col-span-2 flex justify-center mt-6 gap-4">
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    viewSaveButton={false}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled}
                  />
                </div>
              </form>
            </div>
          </div>
        )}
        <MainPopup
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={handleIssueView}
        >
          <div>
            <PopUpScreenTitle
              title="Issues"
              setpopUpOpen={setpopUpOpen}
              hederDetails={true}
            />

            <LaundryIssuePopup data={viewPopupData} data1={viewPopupChildData} />
          </div>

        </MainPopup>
        <MainPopup
          popUpOpen={popUpReceiptOpen}
          setpopUpOpen={setpopUpReceiptOpen}
          Open={handleReceiptView}
        >
          <div>
            <PopUpScreenTitle
              title="Receipts"
              setpopUpOpen={setpopUpReceiptOpen}
              hederDetails={true}
            />

            <LaundryReceiptViewPopup data={viewPopupData1} data1={viewPopupChildData1} />
          </div>
        </MainPopup>


        <MainPopup
          popUpOpen={popUpOpen1}
          setpopUpOpen={setpopUpOpen1}
          Open={handlePopup}
        >
          <div>
            <PopUpScreenTitle
              title="Laundry Receipt"
              setpopUpOpen={setpopUpOpen1}
              hederDetails={true}
            />

            <LaundryReceiptPopup data={viewPopupData2} data1={viewPopupChildData2} />
          </div>
          <PopUpButtons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            viewDetails={viewDetails}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled ? true : false}
          />
        </MainPopup>

      </MainLayout>
    </div>
  );
};

export default LaundryReceipt;
